module.exports = __webpack_public_path__ + "img/ntlogo.9614c79e.png";